import { Container } from "./container"
import { useAnimateOnScroll } from './useAnimateOnScroll'
import { ImageWithFallback } from "./image"

export function BlockImage(props: { block: BlockImage }) {
  const { block } = props
  useAnimateOnScroll()

  return <Container block={block}>
    <div className="fade-up-0 image-container"
      data-animation="animate__fadeInUp">
      <ImageWithFallback filename={block.image} alt="" />
    </div>
  </Container>

}